import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BadgeSize } from '@capital-access/common/utils';
import { PriorityRating } from '../../models';

@Component({
  selector: 'ca-institution-rating',
  templateUrl: './institution-rating.component.html',
  styleUrls: ['./institution-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstitutionRatingComponent {
  @Input() priorityRating!: PriorityRating;
  @Input() size = BadgeSize.Xs;
  @Input() rootCssClass = '';
  @Input() isCustomRating = false;

  get ratingValue() {
    return this.priorityRating === PriorityRating.NR ? null : this.priorityRating;
  }

  get localizedValue() {
    switch (this.priorityRating) {
      case PriorityRating.HM:
        return 'OV';
      case PriorityRating.HT:
        return 'UN';
      default:
        return this.priorityRating;
    }
  }

  get colorClass() {
    switch (this.priorityRating) {
      case PriorityRating.H:
      case PriorityRating.HM:
      case PriorityRating.HT:
        return 'ca-holder-targets-badge';
      case PriorityRating.T1:
      case PriorityRating.T2:
      case PriorityRating.T3:
        return 'ca-non-holder-badge';
      case PriorityRating.NT:
        return 'ca-nt-badge';
      case PriorityRating.SWF:
        return 'ca-swf-badge';
      default:
        return '';
    }
  }
}
